import React from 'react';
import './ProveSection.css';

function ProveSection() {
  return (
    <section className="pm-web-sec pm-web-prove">
      <div className="pm-prove-glow pm-prove-glow--a" aria-hidden="true"></div>
      <div className="pm-prove-glow pm-prove-glow--b" aria-hidden="true"></div>
      <div className="pm-prove-grid" aria-hidden="true"></div>

      <div className="pm-web-wrap pm-web-wrap--narrow">
        <div className="pm-prove-head">
          <span className="pm-web-eyebrow pm-reveal">The protocol that powers our agents</span>
          <h2 className="pm-prove-word pm-reveal" style={{ '--reveal-delay': '80ms' }}>PROVE</h2>
          <p className="pm-prove-sub pm-reveal" style={{ '--reveal-delay': '140ms' }}>
            <strong>P</strong>rotocol for <strong>R</strong>obust <strong>O</strong>rdered <strong>V</strong>erification of <strong>E</strong>vidence
          </p>
        </div>

        <ol className="pm-prove-chain pm-reveal" style={{ '--reveal-delay': '200ms' }}>
          {[['P','Protocol'],['R','Robust'],['O','Ordered'],['V','Verification'],['E','Evidence']].map(([letter, word], i) => (
            <li key={letter} className="pm-prove-node" style={{ '--i': i }}>
              <span className="pm-prove-node__letter">{letter}</span>
              <span className="pm-prove-node__word">{word}</span>
            </li>
          ))}
        </ol>

        <p className="pm-prove-body pm-reveal" style={{ '--reveal-delay': '260ms' }}>
          By transforming standard agentic decision-making from open-ended loops, where the AI acts as its own judge, into a highly controlled protocol, we bring true reliability and certainty to your workflows. This ensures <em>accurate</em>, <em>hallucination-free results</em> backed entirely by a definitive, easily verifiable audit trail.
        </p>

        <div className="pm-prove-advantage pm-reveal" style={{ '--reveal-delay': '320ms' }}>
          <div className="pm-prove-adv-head">The PROVE advantage <span>vs. standard agents</span></div>
          <div className="pm-prove-stats">
            <div className="pm-prove-stat">
              <div className="pm-prove-stat__num">96<span className="pm-prove-stat__unit">%</span></div>
              <div className="pm-prove-stat__label">Reduction in errors</div>
            </div>
            <div className="pm-prove-stat__div" aria-hidden="true"></div>
            <div className="pm-prove-stat">
              <div className="pm-prove-stat__num"><span className="pm-prove-stat__pre">up to</span>3<span className="pm-prove-stat__unit">×</span></div>
              <div className="pm-prove-stat__label">More efficient</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProveSection;
